import { createContext, useContext, useState, useEffect } from "react";

const GlobalLoadingContext = createContext(null);

let activeRequests = 0;
let externalStart;
let externalStop;

export const GlobalLoadingProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const startLoading = (customMessage) => {
    activeRequests += 1;

    if (!loading) {
      setMessage(customMessage || getDefaultMessage());
      setLoading(true);
    }
  };

  const stopLoading = () => {
    activeRequests = Math.max(activeRequests - 1, 0);

    if (activeRequests === 0) {
      setLoading(false);
      setMessage("");
    }
  };

  // 🔑 registramos referencias UNA VEZ
  useEffect(() => {
    externalStart = startLoading;
    externalStop = stopLoading;
  }, []);

  return (
    <GlobalLoadingContext.Provider value={{ loading, message }}>
      {children}
    </GlobalLoadingContext.Provider>
  );
};

export const useGlobalLoadingState = () => {
  return useContext(GlobalLoadingContext)?.loading;
};

export const useGlobalLoadingMessage = () => {
  return useContext(GlobalLoadingContext)?.message;
};

/* 👉 funciones que Axios puede usar */
export const startGlobalLoading = (msg) => {
  externalStart && externalStart(msg);
};

export const stopGlobalLoading = () => {
  externalStop && externalStop();
};

const getDefaultMessage = () => {
  const lang = localStorage.getItem("selectedLanguage");
  if (lang === "ES") return "Por favor, espera...";
  if (lang === "PT") return "Por favor, aguarde...";
  return "Please wait...";
};
